import React from 'react';

import './search-bar.css';

function SearchBar() {
  return <input type="search" className="page__ya-search" placeholder="Поиск" />;
}

export default SearchBar;
